module.exports = __webpack_public_path__ + "static/media/newFeatures5.078efc91.jpeg";